export enum EscalationQueue {
  CWYAUDLVL1 = 'CWYAUDLVL1',
  CWYAUDLVL2 = 'CWYAUDLVL2',
  CWYAUDLVL3 = 'CWYAUDLVL3',
  CWYAUDLVL4 = 'CWYAUDLVL4',
}
